import { api } from './client'

export const getAssets = async () => {
  const { data } = await api.get('/operating-costs/assets')
  return data
}

export const createAsset = async (payload) => {
  const { data } = await api.post('/operating-costs/assets', payload)
  return data
}

export const postDepDueAll = async () => {
  const { data } = await api.post('/operating-costs/assets/post-due')
  return data
}

export const postDepDueOne = async (assetId) => {
  const { data } = await api.post(`/operating-costs/assets/post-due/${assetId}`)
  return data
}

export const previewPostDue = async (assetId) => {
  const { data } = await api.get('/operating-costs/assets/post-due/preview', { params: assetId ? { asset_id: assetId } : {} })
  return data
}

export const getAssetsDueCount = async () => {
  const { data } = await api.get('/operating-costs/assets/due-count')
  return data
}

export const getAsset = async (assetId) => {
  const { data } = await api.get(`/operating-costs/assets/${assetId}`)
  return data
}

export const updateAsset = async (assetId, payload) => {
  const { data } = await api.patch(`/operating-costs/assets/${assetId}`, payload)
  return data
}

export const getAssetSchedule = async (assetId) => {
  const { data } = await api.get(`/operating-costs/assets/${assetId}/schedule`)
  return data
}

export const disposeAsset = async (assetId, payload) => {
  const { data } = await api.post(`/operating-costs/assets/${assetId}/dispose`, payload)
  return data
}

export const reverseDepreciation = async (assetId, payload) => {
  const { data } = await api.post(`/operating-costs/assets/${assetId}/reverse-depreciation`, payload)
  return data
}

export const uploadAssetFile = async (file) => {
  const fd = new FormData()
  fd.append('file', file)
  const { data } = await api.post('/operating-costs/assets/upload-file', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  return data
}

export const assetFileUrl = (assetId) => `/api/operating-costs/assets/${assetId}/file`

export const getPrepaids = async () => {
  const { data } = await api.get('/operating-costs/prepaids')
  return data
}

export const createPrepaid = async (payload) => {
  const { data } = await api.post('/operating-costs/prepaids', payload)
  return data
}

export const amortizePrepaidsDue = async () => {
  const { data } = await api.post('/operating-costs/prepaids/amortize-due')
  return data
}

export const amortizePrepaidOne = async (prepaidId) => {
  const { data } = await api.post(`/operating-costs/prepaids/amortize-one/${prepaidId}`)
  return data
}

export const postSGA = async (payload) => {
  const { data } = await api.post('/operating-costs/sga', payload)
  return data
}

// Running costs, one row per entry: [{je_id, je_no, date, what, category,
// kind: 'entered'|'bill'|'auto', account, vendor_name, paid_from, amount}]
export const getExpenses = async ({ start, end } = {}) => {
  const params = {}
  if (start) params.start = start
  if (end) params.end = end
  const { data } = await api.get('/operating-costs/expenses', { params })
  return data
}

// Choices for recording an expense: { categories, expense_accounts, default_expense_code, paid_from }
export const getExpenseSetup = async () => (await api.get('/operating-costs/expense-setup')).data

// One expense with its accounts, bill (on account) and attached files.
export const getExpense = async (jeId) => (await api.get(`/operating-costs/expenses/${jeId}`)).data

// Attach bills or receipts (PDF or photos) to an expense; returns its files.
export const uploadExpenseFiles = async (jeId, files) => {
  const fd = new FormData()
  ;[...files].forEach((f) => fd.append('file', f))
  const { data } = await api.post(`/operating-costs/expenses/${jeId}/files`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  return data
}

export const deleteExpenseFile = async (fileId) => (await api.delete(`/operating-costs/expense-files/${fileId}`)).data

export const expenseFileUrl = (fileId, { download = false } = {}) => `/api/operating-costs/expense-files/${fileId}${download ? '?download=1' : ''}`

// Pause, resume or complete a prepaid: status Active | Paused | Completed.
export const updatePrepaidStatus = async (prepaidId, status) => (await api.patch(`/operating-costs/prepaids/${prepaidId}`, { status })).data
